module.exports = __webpack_public_path__ + "img/htu-6-1.ca783a9e.png";